import styles from "./LoginScreen.module.css";
import AuthLayout from "./AuthLayout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  login,
  signInWithApple,
  signInWithGoogle,
} from "./AuthManager";
import { updateUser } from "./authAPI";
import { useDispatch } from "react-redux";
import { logIn } from "./authSlice";
import LoadingScreen from "../common/LoadingScreen";
import { ServerStatus, fetchServerStatus } from "../common/serverStatus";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../configurations/firebaseConfig";

function LoginScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [serverStatus, setServerStatus] = useState<ServerStatus>();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        checkServerInspect();
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    if (serverStatus !== undefined && serverStatus !== null) {
      switch (serverStatus) {
        case ServerStatus.Maintenance:
          navigate("/maintenance");
          break;
        case ServerStatus.Running:
          navigate("/");
          break;
      }
    }
  }, [navigate, serverStatus]);

  async function checkServerInspect() {
    try {
      setServerStatus(await fetchServerStatus());
    } catch (error) {
      if (error instanceof Error) {
        alert(error.message);
      }
    }
  }

  async function handleClickGoogleLoginButton() {
    try {
      setIsLoading(true);
      await signInWithGoogle();
      await updateUser();
      setIsLoading(false);
      login();
      dispatch(logIn());
    } catch (error) {
      setIsLoading(false);
      alert(error);
    }
  }

  async function handleClickAppleLoginButton() {
    try {
      setIsLoading(true);
      await signInWithApple();
      await updateUser();
      setIsLoading(false);
      login();
      dispatch(logIn());
    } catch (error) {
      setIsLoading(false);
      alert(error);
    }
  }

  function handleClickEmailLoginButton() {
    navigate("/login/email");
  }

  function handleClickSignUpButton() {
    navigate("/login/sign-up");
  }

  const publicUrl = process.env.PUBLIC_URL;

  return (
    <>
      <AuthLayout
        hero={
          <div className={styles.hero}>
            <h1 className={styles.heroTitle}>{t("LandingHeroTitle")}</h1>
            <p className={styles.heroNote}>{t("LandingHeroNote")}</p>
          </div>
        }
      >
        <button
          type="button"
          className={`${styles.socialButton} ${styles.google}`}
          onClick={() => handleClickGoogleLoginButton()}
        >
          <img
            src={`${publicUrl}/iconImgLoginGoogle.png`}
            alt=""
            className={styles.socialIcon}
          />
          {t("signin_google")}
        </button>
        <button
          type="button"
          className={`${styles.socialButton} ${styles.apple}`}
          onClick={() => handleClickAppleLoginButton()}
        >
          <svg
            className={styles.socialIcon}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden
          >
            <path d="M16.4 12.6c0-2.6 2.1-3.8 2.2-3.9-1.2-1.8-3.1-2-3.7-2-1.6-.2-3.1.9-3.9.9-.8 0-2-.9-3.4-.9-1.7 0-3.3 1-4.2 2.6-1.8 3.1-.5 7.7 1.3 10.2.8 1.2 1.8 2.6 3.1 2.6 1.3-.1 1.7-.8 3.3-.8 1.5 0 1.9.8 3.3.8s2.2-1.3 3-2.5c1-1.4 1.3-2.7 1.4-2.8-.1 0-2.4-.9-2.4-4.2zM13.9 5c.7-.8 1.2-2 1-3.1-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.9-1 3 1.1.1 2.2-.6 2.9-1.4z" />
          </svg>
          {t("signin_apple")}
        </button>
        <div className={styles.emailLinks}>
          <button
            type="button"
            className={styles.textLink}
            onClick={() => handleClickEmailLoginButton()}
          >
            {t("signin_whith_email")}
          </button>
          <span aria-hidden>|</span>
          <button
            type="button"
            className={styles.textLink}
            onClick={() => handleClickSignUpButton()}
          >
            {t("signin_email")}
          </button>
        </div>
      </AuthLayout>
      {isLoading === true ? <LoadingScreen /> : null}
    </>
  );
}

export default LoginScreen;
